"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormField = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormFieldMixin = require("../../mixins/components/FormFieldMixin");
var StyledFormField = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledFormField",
  componentId: "c11n-8-107-0__sc-144pzcf-0"
})(["", ""], _FormFieldMixin.FormFieldMixin);
exports.StyledFormField = StyledFormField;